/**
 * 「나」 탭 사주 · 별자리 정보 지우기 (처리방침 11장, DEV-07z4 2 · D102).
 * 한 번 더 묻고 지움: 생년월일 · 계산 결과 · 별 계산이 같이 지워지고, 다시 입력할 때까지 멤버가 먼저 생일을 묻지 않음
 */
import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { errorMessageOf } from '../../api/client.js';
import * as meApi from '../../api/me.js';
import { BottomSheet } from '../../components/BottomSheet.jsx';

export function SajuDelete({ onDeleted }) {
    const [asking, setAsking] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    async function remove() {
        setBusy(true);
        setError(null);
        try {
            await meApi.deleteMySaju();
            setAsking(false);
            onDeleted();
        } catch (failure) {
            setError(errorMessageOf(failure, '지우지 못했어요. 잠시 후 다시 해 주세요.'));
        } finally {
            setBusy(false);
        }
    }

    return (
        <>
            <button
                type="button"
                aria-label="사주 정보 지우기"
                title="사주 정보 지우기"
                onClick={() => setAsking(true)}
                className="flex size-8 items-center justify-center rounded-full text-text-secondary active:bg-surface"
            >
                <Trash2 size={16} strokeWidth={1.8} aria-hidden="true" />
            </button>
            <BottomSheet open={asking} onClose={() => !busy && setAsking(false)} label="사주 정보 지우기">
                <h2 className="m-0 text-[18px] font-semibold">사주 정보를 지울까요?</h2>
                <p className="m-0 text-caption text-text-secondary">생일과 풀이 계산이 같이 지워져요.</p>
                {error ? <p role="alert" className="m-0 text-caption text-error">{error}</p> : null}
                <div className="mt-2 flex gap-2">
                    <button type="button" disabled={busy} onClick={() => setAsking(false)} className="h-12 flex-1 rounded-card border border-hairline text-[15px] font-semibold disabled:opacity-40">
                        취소
                    </button>
                    <button type="button" disabled={busy} onClick={remove} className="h-12 flex-1 rounded-card bg-error text-[15px] font-semibold text-white disabled:opacity-40">
                        지울게요
                    </button>
                </div>
            </BottomSheet>
        </>
    );
}
